import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { User } from '../types/user';
import { shareReplay, map, catchError } from 'rxjs/operators';
import { Version } from '../types/version';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private currentUser$: Observable<User>;

  constructor(private readonly http: HttpClient, @Inject('BASE_URL') private readonly originUrl: string) { }

  public get currentUser(): Observable<User> {
    if (!this.currentUser$) {
      this.currentUser$ = this.getCurrentUser().pipe(
        shareReplay(1)
      );
    }
    return this.currentUser$;
  }

  public getCurrentUser(): Observable<User> {
    this.currentUser$ = this.http.get(this.originUrl + 'api/user').pipe(
      map(result => {
          const user: User = new User();
          Object.assign(user, result);
          return user as User;
      }), catchError(err => {
        return throwError(err);
      })
    );
    return this.currentUser$;
  }

  public getVersion(): Observable<Version> {
    return this.http.get<Version>(this.originUrl + 'api/user/version');
  }
}
